import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_66c6e44b";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_66c6e44b" };
/** script content **/
require("./tab.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Ftab66c6e44b%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftab-bar%2Ftab.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_66c6e44b"],
    ctorType: "component",
    outputPath: "components/tab66c6e44b/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
